// Site-wide SEO constants — single source of truth for the production origin
// and the default Open Graph share image, used to build absolute URLs
// (canonical, og:url, og:image, breadcrumb JSON-LD) without requiring a local
// .env file (see usePageHead.js, Breadcrumbs.vue, ContentPage.vue, and the
// four markdown detail views).
//
// SITE_URL must be kept in sync with vite.config.mjs's ssgOptions.baseUrl —
// that's build-time config and can't be imported into client code, so the
// value is deliberately duplicated rather than shared.
export const SITE_URL = 'https://sylviarodgerinstitute.au'

// Sitewide default share image (jk-35) — used by every page that doesn't set
// its own ogImage/thumbnail/image. Exactly 1200x630 (the recommended OG
// size), so its dimensions are known and always correct for this one image;
// a page-specific image's dimensions aren't known, so callers only emit
// DEFAULT_OG_IMAGE_WIDTH/HEIGHT/TYPE/ALT when they're actually using this
// default, not when overriding with their own image.
// Replaced 2026-09-09. Deliberately a NEW filename rather than an overwrite of
// the previous launch.png: social platforms cache og:image by URL for weeks, so
// overwriting in place would have left Facebook/LinkedIn/Slack serving the old
// card with no reliable way to refresh links already posted. launch.png is kept
// on disk (not referenced here) so those existing shares still resolve if a
// platform re-fetches them.
export const DEFAULT_OG_IMAGE = '/open-graph/social-card.png'
export const DEFAULT_OG_IMAGE_WIDTH = '1200'
export const DEFAULT_OG_IMAGE_HEIGHT = '630'
export const DEFAULT_OG_IMAGE_TYPE = 'image/png'
export const DEFAULT_OG_IMAGE_ALT = "Sylvia Rodger Institute — the independent national source of evidence for best practice in relation to autism across the lifespan and the spectrum."

// GSC indexing fix (2026-09-24): the host redirects no-slash -> trailing-slash
// (e.g. /our-approach -> /our-approach/), but canonical/og:url/sitemap/internal
// links used to omit it — Google treated the two forms as duplicates and indexed
// neither. Every internal path now goes through this before being rendered as a
// href or written into canonical/og:url/sitemap.xml. Pure JS, no Vue/browser
// dependency, so scripts/build.mjs and vite.config.mjs import it directly
// (relative path) rather than duplicating the logic a third time.
export function withTrailingSlash(path) {
  if (typeof path !== 'string' || !path || path === '/') return path
  if (/^[a-z][a-z0-9+.-]*:/i.test(path) || path.startsWith('//')) return path // http(s):, mailto:, tel:, protocol-relative
  if (path.startsWith('#')) return path
  if (path.endsWith('/')) return path
  const lastSegment = path.split('/').pop()
  if (lastSegment.includes('.')) return path // file-like (.pdf, .xml, .jpg…) — leave alone
  return `${path}/`
}
